// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__mty7H","label":"Completed_label__FraCv"};